// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ftzClor[data-v-5a4e4a25]{color:#999}[data-v-5a4e4a25] .el-card__body{padding:15px}[data-v-5a4e4a25] .el-tabs__nav-wrap:after{position:static!important}[data-v-5a4e4a25] .el-card__header{padding:8px 15px;line-height:34px;font-size:14px;border:none}.pdtitle[data-v-5a4e4a25]{line-height:25px;background:#eff6ff;width:25px;height:25px;display:inline-block;text-align:center;border-radius:50%}.join-dialog[data-v-5a4e4a25] .el-dialog__body{padding-bottom:0}", ""]);
// Exports
module.exports = exports;
